import React from 'react'
import './Order1.css'
// import moment from 'moment'
import Purchasedproduct from '../Components/Purchasedproduct'

function Order1({ order }) {
    console.log("*********************")
    console.log(order);
    console.log(order.data);
    console.log(order.data.basket);
    
    

    return(
        <div className='order'>

        <h1>{order.length}</h1>
        {

order.data.basket.map(item=>(
    <Purchasedproduct key={item.id}
    id={item.id}
    title={item.prdName}
    image={item.img}
    price={item.price}
    reviews={item.reviews}

    />

))

}
        </div>
    )
}
export default Order1;